import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HeroComponent.module.css';
import womanImage from '../../../../Images/newLandingPage/hero.jpg'; 

const HeroComponent = () => {
    const navigate = useNavigate();
    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                <div className={styles.content}>
                    {/* Main Headline */}
                    <h1 className={styles.headline}>
                        <span className={styles.highlight}>Your 24/7 AI Closer —</span>
                        Every Lead Answered.
                        Every Deal Tracked.
                    </h1>

                    {/* Subheadline */}
                    <p className={styles.subheadline}>
                        Toxbox automatically picks up every call, speaks like a real human, qualifies leads, books appointments, and syncs everything into your CRM.
                    </p>

                    <p className={styles.integrations}>
                        Works instantly with Meta Ads, Google Ads, Salesforce, Hubspot, and 100+ tools.
                    </p>

                    <button onClick={() => navigate("/login")} className={styles.trialButton}>Start Free Trial</button>
                </div>

                {/* Right Side - Visuals */}
                <div className={styles.visuals}>
                    {/* Floating Cards */}
                    <div className={`${styles.card} ${styles.cardTop}`}>
                        <div className={styles.cardHeader}>Features</div>
                        <div className={styles.contactItem}>
                            <span>AI Call Automation</span>
                            <label className={styles.toggle}>
                                <input type="checkbox" defaultChecked disabled />
                                <span className={styles.slider}></span>
                            </label>
                        </div>
                        <div className={styles.contactItem}>
                            Real-Time Analytics
                             <label className={styles.toggle}>
                                <input type="checkbox" defaultChecked disabled />
                                <span className={styles.slider}></span>
                            </label>
                        </div>
                        <div className={styles.contactItem}>
                            Built-In CRM
                             <label className={styles.toggle}>
                                <input type="checkbox" defaultChecked disabled />
                                <span className={styles.slider}></span>
                            </label>
                        </div>
                    </div>

                    {/* Woman with Phone */}
                    <div className={styles.womanCard}>
                        <img src={womanImage} alt="Professional woman on phone" className={styles.womanImage} />
                        <div className={styles.womanBadge}>
                            <div className={styles.badgeLine}><strong>Powered by xAI</strong></div>
                            <div className={styles.badgeLine}>Handles 1,000+<br />smart calls daily</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroComponent;